const reserveBoxStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    imgCont: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    form: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      flexWrap: 'wrap',
      paddingTop: theme.spacing(1.5),
    },
    inputStyles: {
      // height: 25,
      minWidth: 140,
      // maxWidth: 300,
      // width: 166,
      // height: 43,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(1.5),
      // marginBottom: theme.spacing(1.5),
      flex: 1,
      // borderRadius: "6px",
      // borderWidth: 2,
      // borderStyle: "solid",
      // paddingLeft: 5,
      // paddingRight: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
      // '& .MuiOutlinedInput-notchedOutline': {
      //   borderColor: 'green',
      // },
    },
    specInputStyles: {
      width: '100%',
      marginLeft: theme.spacing(1),
      flex: 1,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
      },
      '& .MuiInputLabel-outlined .MuiInputLabel-shrink': {
        transform: 'translate(14px, -12px) scale(0.75)',
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
      // '& .MuiOutlinedInput-notchedOutline': {
      //   borderColor: 'green',
      // },
    },
    boxSelectCont: {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      flex: 1,
      // paddingLeft: 5,
      // paddingRight: 5,
    },
    boxSelectContSpec: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(1.5),
      // marginBottom: theme.spacing(1.5),
      flex: 1,
      // paddingLeft: 5,
      // paddingRight: 5,
    },
    multi: {
      flex: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderWidth: 2,
      borderStyle: 'solid',
      marginBottom: '14px',
    },
    borderStadiumCls: {
      border: '1px solid #e3e3e3',
      borderRadius: 10,
      padding: '14px',
    },
    btnContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    button: {
      // marginRight: theme.spacing(1),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      alignSelf: 'center',
      // marginBottom: theme.spacing(0.5),
      // marginRight: theme.spacing(0.5),
      // marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    errorCls: {
      color: 'red',
      fontSize: 10,
      position: 'absolute',
      left: 0,
      bottom: '-15px',
    },
    positionCls: {
      position: 'relative',
    },
    phoneErrorCls: {
      color: 'red',
      fontSize: 10,
      position: 'absolute',
      left: 0,
      bottom: '-15px',
      paddingLeft: 5,
    },
  };
};

export default reserveBoxStyles;
